export default "__VITE_ASSET__755f9c8f__"